import { Pipe, PipeTransform } from '@angular/core';


/**
 * Truncates a string to a maximum number of characters for display.
 */
@Pipe({
    name: 'truncateWithEllipsis',
    standalone: true
})
export class TruncateWithEllipsisPipe implements PipeTransform {
    /**
     * Returns the leading characters of a string followed by an ellipsis.
     *
     * @param input String to truncate.
     * @param limit Maximum number of characters to keep before the ellipsis.
     * @returns Truncated display text, or an empty string for nullish input.
     */
    transform(input: string | null | undefined, limit: number): string {
        if (input) {
            return input.substring(0, limit) + '...';
        }

        return '';
    }
}
